<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const props = withDefaults(
  defineProps<{
    dateTime?: string,
    showTime?: boolean
    }>(),
  {
    dateTime: ''
  }
)

const locale = useI18n().locale.value as 'de' | 'en'
const timezoneLocale = locale.replace('de', 'de-DE').replace('en', 'en-GB')

const options = {
  de: {
    timeZone: 'Europe/Berlin',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  },
  en: {
    timeZone: 'Europe/Berlin',
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }
}

const optionsWithTime = {
  de: {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    minute: '2-digit'
  },
  en: {
    timeZone: 'Europe/Berlin',
    hour: '2-digit',
    minute: '2-digit'
  }
}

const displayDate = computed(() => {
  if (props.dateTime && props.dateTime !== '') {
    const displayDate = new Date(props.dateTime)

    const formattedDate = new Intl.DateTimeFormat(timezoneLocale, options[locale]).format(displayDate)
    const formattedTime = new Intl.DateTimeFormat(timezoneLocale, optionsWithTime[locale]).format(displayDate)

    return props.showTime ? `${formattedDate}, ${formattedTime}` : formattedDate
  }
  return ''
})
</script>

<template>
  <time>
    {{ displayDate }}
  </time>
</template>
